import { Document } from "../store/ducks/merchants.ducks"
import { getFileExtension } from "./batchDocuments"
import { capitalizeFirstLetter } from "./string"

export const filterDocs =
  (search: string, merchantName: string) => (document: Document) => {
    if (!document) {
      return
    }

    return (
      merchantName.toLowerCase().includes(search.toLowerCase()) ||
      search.toLowerCase().includes(merchantName.toLowerCase()) ||
      document.amount?.toLowerCase().includes(search.toLowerCase()) ||
      document.document_reference
        ?.toLowerCase()
        .includes(search.toLowerCase()) ||
      document.user_file_name?.toLowerCase().includes(search.toLowerCase()) ||
      document.original_file_name?.toLowerCase().includes(search.toLowerCase())
    )
  }

export function getDocumentTypeDisplayed(document: Document) {
  const extension = getFileExtension(document.original_file_name)
  return capitalizeFirstLetter(extension.replace(".", ""))
}